import { useStore } from '@nanostores/react';
import { $pageSettings } from '../store/pageSettingsStore';

export const usePageSettings = () => {
    const value = useStore($pageSettings);
    return { ...value, isFromMobileApp: ['android-app', 'ios-app'].includes(value?.platform?.type) };
};
